
import MailSVG from "../../../../../icons/mail";
import PrintSVG from "../../../../../icons/print";
import Button from "../../../../../button/button";
import Modal from "../../../../../modal/modal";
import PaymentReceiptPDF from "../../PaymentReceiptPDF";
import Axios from "axios";
import './RePrintReceipt.scss'
import { useState } from "react";
// Function to generate and print the PDF receipt

const RePrintReceipt = ({ isOpen, onClose, receiptData }) => {  // Cambia la forma en que recibes las props
    const [disabledEmailButton,setDisabledEmailButton] = useState(true)
    const handlePrint = async () => {
        const pdfDoc = await PaymentReceiptPDF(receiptData); // Generate the PDF
        pdfDoc.autoPrint();
        window.open(pdfDoc.output('bloburl'), '_blank');
    };

    const handleSendEmailReceipt = async () => {
        try {
            setDisabledEmailButton(true)
            // Genera el PDF primero
            const pdfDoc = await PaymentReceiptPDF(receiptData);
            const pdfBlob = pdfDoc.output("blob"); // Esto te da un Blob usable para FormData
            const formData = new FormData();
            formData.append("pdf", pdfBlob, "recibo.pdf");  // ✅ agrega nombre al archivo
            formData.append("studentEmail", receiptData.students[0].email);
            formData.append("studentName", receiptData.students[0].name);
            const response = await Axios.post(
                process.env.REACT_APP_API_URL + "sendReceptionEmail/",
                formData,
                {
                    headers: {
                        "x-access-token": localStorage.getItem("token"),
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
    
            if (response.data.success) {
                alert('Correo enviado exitosamente.');
                setDisabledEmailButton(false)
            } else {
                console.error('Error al enviar el correo:', response.data.message);
            }
        } catch (error) {
            console.error("Error enviando el correo:", error);
        }
    };
    
    return (
        <Modal onClose={onClose} isOpen={isOpen} overlayClick={true}>
            <div className="print-receipt">
                <div className="title-contain">
                    <h1 className="title-3">Re-Imprimir recibo</h1>
                </div>

                <div className="print-receipt-buttons">
                    <Button text="Imprimir recibo" Icon={PrintSVG} onClick={handlePrint} />
                    <Button text="Enviar por Correo" Icon={MailSVG} onClick={handleSendEmailReceipt} disabled={disabledEmailButton}/>
                </div>
            </div>
        </Modal>
    );
};


export default RePrintReceipt;
